module.exports = __webpack_public_path__ + "img/global-commbook-empty.515604e8.png";